// extracted by mini-css-extract-plugin
module.exports = {"root":"NavLink_root__2B33N","link":"NavLink_link__2nqxb","active":"NavLink_active__3COwS"};